<!-- <div *ngIf="show" class="alert-component">
	<div *ngIf="message"
		[ngClass]="{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error', 'alert-warning': message.type === 'warning' }">
		{{message.text}}
		<button (click)="hideModal()" class="btn btn-danger">Chiudi</button>
	</div>
</div> -->
<div *ngIf="show && message" id="alert-area" class="alert-area alert-component {{ message.type }}">
	<div *ngIf="message" class="alert-box">
		<div class="alert-content">{{message.text}}</div><a class="alert-close" (click)="hideModal()"
			[routerLink]="null"></a>
	</div>
</div>